import Breadcrumbs from './Breadcrumbs'
import './Breadcrumbs.css'

export default Breadcrumbs



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/index.js